import { Incident } from '@src/main/modules/other_incidents/domain/incident.model';
import { UpdateIncidentCommand } from '@src/main/modules/other_incidents/infrastructure/dto/incident.dto';
import { OtherIncidentFilterRequestDto } from '@src/main/modules/other_incidents/infrastructure/dto/other-incident-filter.dto';
import {
  OtherIncidentResponseDto,
  PageResponse,
} from '@src/main/modules/other_incidents/infrastructure/dto/other-incident-response.dto';
import { IncidentsRepository } from '@src/main/modules/other_incidents/infrastructure/incidents.repository';
import { mapIncidentDtoToDomain } from '@src/main/modules/other_incidents/infrastructure/other-incident.mapper';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const path = '/other_incidents';

export const createOtherIncidentHttpRepository = (
  tokenProvider: TokenProvider,
): IncidentsRepository => new OtherIncidentHttpRepository(tokenProvider);

class OtherIncidentHttpRepository implements IncidentsRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async findAll(request: OtherIncidentFilterRequestDto): Promise<PageResponse<Incident>> {
    const token = await this.getAuthToken();
    const response = await api.get<PageResponse<OtherIncidentResponseDto>>(
      `${path}/all`,
      token,
      request,
    );
    return {
      ...response,
      items: (response.items ?? []).map(mapIncidentDtoToDomain),
    };
  }

  async findAllExport(request: OtherIncidentFilterRequestDto): Promise<PageResponse<Incident>> {
    const token = await this.getAuthToken();
    const response = await api.get<PageResponse<OtherIncidentResponseDto>>(
      `${path}/all/export`,
      token,
      request,
    );

    return {
      ...response,
      items: (response.items ?? []).map(mapIncidentDtoToDomain),
    };
  }

  async updateIncident(command: UpdateIncidentCommand): Promise<void> {
    const token = await this.getAuthToken();
    await api.patch<string>(`${path}/update`, token, {
      ...command,
    });
  }

  async postColumbusIncident(ids: string[]): Promise<Incident[]> {
    const token = await this.getAuthToken();

    const response = await api.post<Incident[]>(`${path}/send_to_columbus`, token, ids);

    return response;
  }
}
